import Parse from 'html-react-parser';

function BMP20153(props) {
    let svgCode =
    `<svg width="80" height="88" viewBox="0 0 80 88" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="80" height="42" fill="${props.backgroundFill}"/>
        <rect y="44" width="80" height="42" fill="${props.backgroundFill}"/>
        <path d="M24 64H56V66H24V64Z" fill="${props.highlightColour}"/>
        <path d="M64 65L55.75 71.9282V58.0718L64 65Z" fill="${props.highlightColour}"/>
        <path d="M16 65L24.25 71.9282V58.0718L16 65Z" fill="${props.highlightColour}"/>
        <path d="M38 60H42V62H38V60Z" fill="${props.highlightColour}"/>
        <path d="M38 56H42V58H38V56Z" fill="${props.highlightColour}"/>
        <path d="M38 68H42V70H38V68Z" fill="${props.highlightColour}"/>
        <path d="M38 72H42V74H38V72Z" fill="${props.highlightColour}"/>
        <path d="M24 20H56V22H24V20Z" fill="${props.darkFill}"/>
        <path d="M64 21L55.75 27.9282V14.0718L64 21Z" fill="${props.darkFill}"/>
        <path d="M16 21L24.25 27.9282V14.0718L16 21Z" fill="${props.darkFill}"/>
        <path d="M38 16H42V18H38V16Z" fill="${props.darkFill}"/>
        <path d="M38 12H42V14H38V12Z" fill="${props.darkFill}"/>
        <path d="M38 24H42V26H38V24Z" fill="${props.darkFill}"/>
        <path d="M38 28H42V30H38V28Z" fill="${props.darkFill}"/>
    </svg>`

    props.svgReturn(73, svgCode, "bmp00153", 80, 88);

    const style = {
        display: props.display
    }

    return (
        <div style={style}>
            {Parse(svgCode)}
        </div>
    );
}

export default BMP20153;